import { Link } from "react-router-dom";
import { Clock } from "lucide-react";
import EnquiryBadge from "@/components/EnquiryBadge";
import CompareToggle from "@/components/CompareToggle";

const CATEGORY_LABEL = {
  safari: "Curated Experience",
  beach: "Safari & Beach",
  beach: "Coastal Escape",
};

export default function TourCard({ tour }) {
  return (
    <Link
      to={`/tours/${tour.slug}`}
      data-testid={`tour-card-${tour.slug}`}
      className="group block bg-[#FFFFFF] rounded-3xl overflow-hidden border border-[#E2D5C3] hover:border-[#A6521B]/40 hover:shadow-xl hover:shadow-[#23170E]/8 transition-all duration-300"
    >
      <div className="relative aspect-[4/3] overflow-hidden">
        <img
          src={tour.hero_image}
          alt={tour.title}
          className="w-full h-full object-cover img-hover"
        />
        <div className="absolute top-4 left-4 bg-[#FAF6F0]/95 backdrop-blur rounded-full px-4 py-1.5">
          <span className="font-display italic text-xs uppercase tracking-[0.18em] text-[#A6521B]">
            {CATEGORY_LABEL[tour.category] || "Journey"}
          </span>
        </div>
        <CompareToggle slug={tour.slug} title={tour.title} />
      </div>

      <div className="p-6 md:p-8">
        <EnquiryBadge count={tour.enquiries_last_7d} slug={tour.slug} />
        <h3 className="font-marcellus text-2xl md:text-3xl text-[#23170E] leading-tight group-hover:text-[#A6521B] transition-colors">
          {tour.title}
        </h3>
        <p className="text-sm text-[#23170E]/65 leading-relaxed mt-3 line-clamp-2">{tour.summary}</p>

        {tour.highlights && tour.highlights.length > 0 && (
          <div className="mt-5 pt-5 border-t border-[#E2D5C3]">
            <p className="text-xs uppercase tracking-[0.18em] text-[#23170E]/50 mb-3 font-medium">Highlights</p>
            <ul className="space-y-2">
              {tour.highlights.slice(0, 3).map((h) => (
                <li key={h} className="flex items-start gap-3 text-sm text-[#23170E]/80">
                  <span className="mt-1.5 w-1.5 h-1.5 rounded-full bg-[#A6521B] flex-shrink-0" />
                  <span className="leading-snug">{h}</span>
                </li>
              ))}
            </ul>
          </div>
        )}

        <div className="mt-6 pt-5 border-t border-[#E2D5C3] flex items-center justify-between">
          <div>
            <p className="font-marcellus text-xl text-[#23170E] flex items-center gap-2"><Clock size={16} className="text-[#A6521B]" /> {tour.duration_label}</p>
            <p className="text-xs text-[#23170E]/55 mt-0.5">{tour.park}</p>
          </div>
          <span data-testid={`tour-card-book-${tour.slug}`} className="btn-pill btn-pill-primary text-xs">
            Book Now
          </span>
        </div>
      </div>
    </Link>
  );
}
